<template>
  <div class="mt-5">

    <!-- show login -->
    <div v-if="loginStatus == false">
      <h2 class="underline">Please Login</h2>
      <div class="col pt-1">
        <div class="row p-1">
          <div class="col-6 p-1">
            <span>Username</span>
            <input type="text" v-model="creds.username" class="form-control" />

            <span>Password</span>
            <input type="password" v-model="creds.password" @keyup.enter="login()" class="form-control"/>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <button type="button" @click="login()" class="btn btn-primary">Login</button>
          </div>
        </div>
      </div>
    </div>

    <!-- show log out link -->
    <div v-else class="m-1">
      <button type="button" @click="logout()" class="btn btn-primary">Logout</button>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      creds: {},
      loggedin: false,
    }
  },
  props: ['loginStatus'],
  computed: {
    loginChecker() {
      this.loggedin = this.loginStatus
    }
  },
  vuex: {
    getters: {

    },
    actions: {

    }
  },
  mounted: function() {
    
  },
  methods: {
    login: function() {
      //set local
      let local = this

      //ajax query
      axios({
          method: 'post',
          url: this.$helpers.api() + '/admin/login',
          data: this.creds,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'}
        })
        .then(function (response) {
          local.$helpers.setToken(response)

          //update local status
          local.loggedin = true

          //send data up to parent to change screens
          local.$emit("loginComplete", "")

          //clear form
          local.creds.username = undefined
          local.creds.password = undefined
        })
        .catch(function (error) {
          console.log("login error: ", error)
        });
    },
    logout: function() {
      this.$helpers.setToken("")
      this.loggedin = false

      //send data up to parent to change screens
      this.$emit("logoutComplete", "")
    }
  }
}
</script>

<style>
</style>
